<template>
  <div class="page_content calendar-view">

    <semester-header :stream-uuid="streamUuid"
                     :current-semester="currentSemester"
                     :current-year="currentYear"
                     :parent-component="'Calendar'"
                     :is-planning-stream="isPlanningStream"></semester-header>
                     
  	<div class="calendar-row">
  		<div class="calander-view-section">
  			<!-- <div class="calendar-view-table">
  				<table class="table" style="height: 489px" width="785">
  					<thead>
  						<tr class="schedule_row theader">
  						  <th class="first_cell">Week</th>
  						  <th class="schedule_cell">Monday</th>
  						  <th class="schedule_cell">Tuesday</th>
  						  <th class="schedule_cell">Wednesday</th>
  						  <th class="schedule_cell">Thursday</th>
  						  <th class="schedule_cell">Friday</th>
  						  <th class="schedule_cell">Saturday</th>
  						  <th class="schedule_cell">Sunday</th>
  						</tr>
  					</thead>
  				  <tbody>

  					<tr class="schedule_row" id="08:00:00">
  					  <td class="first_cell time-column">8:00 AM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="09:00:00">
  					  <td class="first_cell time-column">9:00 AM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="10:00:00">
  					  <td class="first_cell time-column">10:00 AM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="11:00:00">
  					  <td class="first_cell time-column">11:00 AM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="12:00:00">
  					  <td class="first_cell time-column">12:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="13:00:00">
  					  <td class="first_cell time-column">1:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="14:00:00">
  					  <td class="first_cell time-column">2:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="15:00:00">
  					  <td class="first_cell time-column">3:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="16:00:00">
  					  <td class="first_cell time-column">4:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="17:00:00">
  					  <td class="schedule_cell time-column">5:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="18:00:00">
  					  <td class="first_cell time-column">6:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="19:00:00">
  					  <td class="first_cell time-column">7:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="20:00:00">
  					  <td class="first_cell time-column">8:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="21:00:00">
  					  <td class="first_cell time-column">9:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  					<tr class="schedule_row" id="22:00:00">
  					  <td class="first_cell time-column">10:00 PM</td>
  					  <td class="schedule_cell" id="monday"></td>
  					  <td class="schedule_cell" id="tuesday"></td>
  					  <td class="schedule_cell" id="wednesday"></td>
  					  <td class="schedule_cell" id="thursday"></td>
  					  <td class="schedule_cell" id="friday"></td>
  					  <td class="schedule_cell" id="saturday"></td>
  					  <td class="schedule_cell" id="sunday"></td>
  					</tr>
  				  </tbody>
  				</table>
  			</div> -->

  		<!-- DIV APPROACH -->
  		<div class="calendar">

  			<div class="calendar_header">
  				<div class="weekday_title">Week</div>
  				<div class="weekday_header">
  					<div class="weekday">Monday</div>
  					<div class="weekday">Tuesday</div>
  					<div class="weekday">Wednesday</div>
  					<div class="weekday">Thursday</div>
  					<div class="weekday">Friday</div>
  					<div class="weekday">Saturday</div>
  					<div class="weekday">Sunday</div>
  				</div>
  			</div>

  			<div class="calendar_details_section">

  				<div class="time_slot_header">
  					<div class="time_slot_row">
  						<div class="time_slot"><span>8 am</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>9 am</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>10 am</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>11 am</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>12 noon</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>1 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>2 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>3 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>4 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>5 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>6 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>7 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>8 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>9 pm</span></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"><span>10 pm</span></div>
  					</div>
  				</div>

  				<div class="time_slot_section">
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>
  					<div class="time_slot_row">
  						<div class="time_slot"></div>
  					</div>

  			<div class="course_detail_block" v-if="formattedCoursesForDivs && formattedCoursesForDivs.length && formattedCoursesForDivs.length > 0">
          		<div v-for="(course, index) in formattedCoursesForDivs">
            			<div @click="courseSelected(course, $event), setActiveClass('course_block_' + index)" :title='course.title' v-b-tooltip.hover.topright class="course_class_time" :id="'course_block_' + index" :class="course.day">
              			<div class="course_details">
              				<span class="icon_close" @click.stop="removeActiveClass" title="close active mode" aria-label="close active mode">x</span>
                				<span class="icon-course icon"></span>
                				<span class="course-title">{{course.title}}</span>

                				<div class='remove_course_container'>
                					<span class="icon-bin2" @click.stop='removeCourseDiv' title="remove this course from my planning stream" aria-label="remove this course from my planning stream"></span>
                				</div>

                				<!--
               	 			<li class="explore_row_options">
                  				<a class="dropdown-toggle" @click.stop="removeButtonClickedDiv(course, $event)">
                    					<span class="fa fa-ellipsis-v icon"></span>
                  				</a>
                				</li>
                				-->
              			</div>

            			</div>

          		</div>
  			</div>

  			</div>
  	  </div>
  		</div>
  			<div id="remove-course" class="remove-course"></div>
  			<div v-if='showRemoveCoursePopover'>
  			  <b-popover :show.sync='showRemoveCoursePopover'
  					target='courseToRemoveContainer' container="remove-course">
  					<div class='content-row' @click.stop='removeCourseDiv'>remove from my stream</div>
  			  </b-popover>
  			</div>
  		</div>
  		<div class="schedule-conflict-section">
  			<div class="header">Course Information</div>
  			<div class="content-section">
  				<div v-if="courseToRemove && courseToRemove.uuid" class="content-row">
  					<div v-if="scheduleCheckFlagMap.showCourseTitle.enabled" class="desc-cont">
  						Course: {{courseToRemove.title}}
  					</div>
  					<div v-if="scheduleCheckFlagMap.showCRN.enabled" class="desc-cont">
  						CRN: {{courseToRemove.CRN}}
  					</div>
  					<div v-if="scheduleCheckFlagMap.showDays.enabled" class="desc-cont">
  						Days: {{courseToRemove.days}}
  					</div>
  					<div v-if="scheduleCheckFlagMap.showTime.enabled" class="desc-cont">
  						Times: {{courseToRemove.times}}
  					</div>
  					<div v-if="scheduleCheckFlagMap.showUnits.enabled" class="desc-cont">
  						Credits: {{courseToRemove.numberOfUnits}}
  					</div>
  					<div v-if="scheduleCheckFlagMap.showInstructor.enabled" class="desc-cont">
  						Instructor: {{courseToRemove.professorOrInstructor}}
  					</div>
            <div v-if="scheduleCheckFlagMap.showBlock.enabled" class="desc-cont">
              Block: {{courseToRemove.block}}
            </div>
            <div v-if="scheduleCheckFlagMap.showGradeLevel.enabled" class="desc-cont">
              Grade Level: {{courseToRemove.gradeLevel}}
            </div>
  				</div>
  			</div>
  		</div>
  	</div>

  </div>
</template>

<script>
  import '../../../assets/module/css/semester/calendarView.min.css'
  import { mapActions, mapState } from 'vuex'
  import SemesterHeader from '../../semester/components/SemesterHeader'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'

  export default {
    name: 'semester-calendar-view',
    props: ['streamUuid', 'currentSemester', 'currentYear', 'isPlanningStream'],
    components: {
      SemesterHeader
    },
    data: () => {
      return {
        dayMap: {'M': 'monday', 'T': 'tuesday', 'W': 'wednesday', 'TR': 'thursday', 'F': 'friday', 'S': 'saturday', 'SU': 'sunday'},
        dayStringToIndex: {'monday': 1, 'tuesday': 2, 'wednesday': 3, 'thursday': 4, 'friday': 5, 'saturday': 6, 'sunday': 7},
        showRemoveCoursePopover: false,
        courseToRemove: {},
        lastClickedCell: {},
        userRole: localStorage.getItem('userrole')
      }
    },
    mounted () {
      // this.loadData()
    },
    created () {
      this.loadData()
    },
    methods: {
      ...mapActions([
        'populateCourses',
        'removeCourseFromStream'
      ]),
      loadData () {
        let streamUuid = this.streamUuid
        let currentSemester = this.currentSemester
        let currentYear = this.currentYear

        if (!streamUuid || !currentSemester || !currentYear) {
          return this.$router.push({ name: 'courseSearchResults' })
        }

        this.clearCoursesDiv()
        this.$forceUpdate()
        this.populateCourses({streamUuid: streamUuid, currentYear: currentYear, currentSemester: currentSemester}).then((response) => {
          let courses = response
          let formattedEntries = []
          courses.forEach(function (course) {
            if (course.meetingDaysFormatted) {
              course.meetingDaysFormatted.forEach((meetingDay) => {
                let courseFormatted = {}
                courseFormatted.uuid = course.uuid
                courseFormatted.title = course.title
                courseFormatted.day = meetingDay.day
                courseFormatted.conflict = meetingDay.conflict
                courseFormatted.conflictCount = 0
                courseFormatted.meetingToTimeFormatted = meetingDay.meetingToTimeFormatted
                courseFormatted.meetingFromTimeFormatted = meetingDay.meetingFromTimeFormatted
                formattedEntries.push(courseFormatted)
              })
            }
          })
          this.addAllCourses(formattedEntries)
          this.$forceUpdate()
        })
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      onShown () {
        console.log('onShown called')
      },
      writeFile (data) {
        const blob = new Blob([data], {type: 'text/plain'})
        const e = document.createEvent('MouseEvents')
        let a = document.createElement('a')
        a.download = 'my_download.ics'
        a.href = window.URL.createObjectURL(blob)
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(e)
      },
      exportAsICal () {
        let streamUuid = this.streamUuid
        let currentSemester = this.currentSemester
        let currentYear = this.currentYear

        this.getICalFile({streamUuid: streamUuid, currentYear: currentYear, currentSemester: currentSemester})
        let iCalFile = this.iCalEvents
        this.writeFile(iCalFile)
      },
      shareButtonClicked () {
        console.log('shareButtonClicked clicked!')
      },
      goToPlanning () {
        console.log('goToPlanning clicked!')
      },
      printButtonClicked () {
        window.print()
      },
      roundDownNearestHour (timeString) {
        // ensure 24 hour time strings are converted to 12 hour
        // e.g. '13:00:00' -> '01:00 PM'
        let formatted = timeString.split(':')[0] + ':00:00' // + timeString.split(':')[1].split(' ')[1]
        return formatted
      },
      range (start, end) {
        return Array.from({length: (end - start)}, (v, k) => k + start)
      },
      firstNumber (timeString) {
        return parseInt(timeString.split(':')[0], 10)
      },
      colorTimeSlots (startTime, endTime, dayIndex, style) {
        let start = this.firstNumber(startTime)
        let end = this.firstNumber(endTime)
        let timeRange = this.range(start, end + 1)
        timeRange.forEach(function (timeSlot) {
          // format the integer to look like a 24-hour time string in the format HH:mm:ss
          if (timeSlot < 10) {
            timeSlot = '0' + timeSlot
          }
          timeSlot = timeSlot + ':00:00'

          let timeRow = document.getElementById(timeSlot)
          let cell = timeRow.cells[dayIndex]
          cell.style.backgroundColor = style
        })
      },
      clearColumn (timeStart, timeEnd, course, day) {
        let timeRowStart = document.getElementById(timeStart)
        let timeRowEnd = document.getElementById(timeEnd)
        let dayIndex = this.dayStringToIndex[day]

        let startCell = timeRowStart.cells[dayIndex]
        let endCell = timeRowEnd.cells[dayIndex]

        startCell.innerHTML = ''
        endCell.innerHTML = ''

        this.colorTimeSlots(timeStart, timeEnd, dayIndex, 'white')
      },
      fillColumnWithCourseData (timeStart, timeEnd, course, day) {
        let timeRowStart = document.getElementById(timeStart)
        let timeRowEnd = document.getElementById(timeEnd)

        // index each column by the day of the week
        // ex)
        //     'monday' -> 1
        //     'tuesday' -> 2, etc..
        let dayIndex = this.dayStringToIndex[day]

        let startCell = timeRowStart.cells[dayIndex]
        let endCell = timeRowEnd.cells[dayIndex]

        // TODO how to display multiple classes on the same line?
        // Right now we just put them in the same cell joined with "AND"
        if (!startCell.innerHTML) {
          startCell.innerHTML = '<span class="icon-course"></span>' + '<span class="course-name">' + course.courseName + '</span>' + '<span class="fa fa-ellipsis-v"></span>'
        } else {
          startCell.innerHTML += '\nAND\n' + course.courseName
        }
        endCell.innerHTML = ''
        let removeCourse = this.removeButtonClicked
        // NOTE: Vue caches the event listeners, clearing it explicity to prevent it from being fired twice
        //       after the courses are re-populated
        $(startCell).unbind('click').click(function (event) {
          removeCourse(course, event.target)
        })

        let cellColor = (course.hasConflict) ? 'red' : 'green'
        if (course.hasConflict) {
          $(startCell).addClass('conflict-class')
        } else {
          $(startCell).addClass('no-conflict')
        }
        this.colorTimeSlots(timeStart, timeEnd, dayIndex, cellColor)
      },
      addCourseToCalendar (course) {
        let roundDownHour = this.roundDownNearestHour
        let fillColumn = this.fillColumnWithCourseData

        course.meetingDaysFormatted.forEach(function (meetingDayFormatted) {
          let day = meetingDayFormatted.day
          let timeStart = roundDownHour(meetingDayFormatted.meetingFromTimeFormatted)
          let timeEnd = roundDownHour(meetingDayFormatted.meetingToTimeFormatted)

          fillColumn(timeStart, timeEnd, course, day)
        })
      },
      removeCourseFromCalendar (course) {
        let roundDownHour = this.roundDownNearestHour
        let clearColumn = this.clearColumn

        course.meetingDaysFormatted.forEach(function (meetingDayFormatted) {
          let day = meetingDayFormatted.day
          let timeStart = roundDownHour(meetingDayFormatted.meetingFromTimeFormatted)
          let timeEnd = roundDownHour(meetingDayFormatted.meetingToTimeFormatted)

          clearColumn(timeStart, timeEnd, course, day)
        })
      },
      removeCourseFromCalendarDiv (courseBlockId, course) {
        let day = course.day
        let startTime = course.meetingFromTimeFormatted
        // let endTime = course.meetingToTimeFormatted
        let isConflict = course.conflict

        let updateStartTimeValue = startTime.replace(/:/g, '_')
        let splittedTime = updateStartTimeValue.split('_')
        // let startTimeInMinute = ((parseInt(splittedTime[0]) * 60) + parseInt(splittedTime[1]))

        // let courseClassSectionWidth = ($('.weekday').innerWidth()) / 2 - 2
        let conflictDayTimeClass = 'class_' + day + '_' + splittedTime[0]

        if (isConflict) {
          let conflictClass = 'conflict ' + conflictDayTimeClass
          $('#' + courseBlockId).removeClass(conflictClass)
        } else {
          let conflictClass = 'no-conflict ' + conflictDayTimeClass
          $('#' + courseBlockId).removeClass(conflictClass)
        }
      },
      addAllCourses (courseList) {
        let courses = courseList
        if (!courses) {
          courses = this.formattedCoursesForDivs
        }
        // TODO uncomment line once div approach is finished
        // let addCourse = this.addCourseToCalendar
        let addCourse = this.setCourseTimingInCalendar
        courses.forEach(function (course, i) {
          addCourse('course_block_' + i, course)
        })
      },
      clearCourses () {
        let courses = this.formattedCourses
        let removeCourse = this.removeCourseFromCalendar
        courses.forEach(function (course) {
          removeCourse(course)
        })
        this.clearLastClickedCell()
        this.hideRemoveCoursePopover()
      },
      clearCoursesDiv () {
        let courses = this.formattedCoursesForDivs
        let removeCourse = this.removeCourseFromCalendarDiv
        courses.forEach(function (course, i) {
          removeCourse('course_block_' + i, course)
        })
        this.clearLastClickedCell()
        this.hideRemoveCoursePopover()
      },
      formatInstructorNames (instructorNames) {
        let names = ''
        let max = 8
        let len = instructorNames.length
        for (let instructorNameIndex in instructorNames) {
          let instructorName = instructorNames[instructorNameIndex]
          if (instructorNameIndex === max) {
            names += ' ...'
            break
          } else if (instructorNameIndex === len - 1 && len > 1) {
            names += ' and '
          } else if (instructorNameIndex > 0) {
            names += ', '
          }
          names += ((instructorName.indexOf('__') === -1) ? instructorName : instructorName.substring(0, instructorName.indexOf('__')))
        }
        return names
      },
      getFormattedInstructorName (course) {
        let instructors = course.instructorNames
        if (instructors && instructors.length > 0) {
          return this.formatInstructorNames(instructors)
        }
        return ''
      },
      removeCourse () {
        let courseToRemove = this.courseToRemove
        if (courseToRemove) {
          let streamUuid = this.streamUuid
          let currentSemester = this.currentSemester
          let currentYear = this.currentYear
          let loadData = this.loadData

          this.removeCourseFromCalendar(courseToRemove)
          const params = {
            streamUuid: streamUuid,
            currentYear: currentYear,
            currentSemester: currentSemester,
            courseData: courseToRemove,
            userRole: this.userRole
          }
          this.removeCourseFromStream(params).then((response) => {
            // NOTE: The backend updates the course's hasConflict status, so we make another call to reflect this here
            // in the UI's color
            loadData()
          })
          this.notifySuccess('Successfully removed \'' + courseToRemove.title + '\' from your stream.')
        }
      },
      removeCourseDiv () {
        let courseToRemove = this.courseToRemove
        if (courseToRemove) {
          let streamUuid = this.streamUuid
          let currentSemester = this.currentSemester
          let currentYear = this.currentYear
          let loadData = this.loadData

          // this.removeCourseFromCalendarDiv(courseToRemove)
          const params = {
            streamUuid: streamUuid,
            currentYear: currentYear,
            currentSemester: currentSemester,
            courseData: courseToRemove,
            userRole: this.userRole
          }
          this.removeCourseFromStream(params).then((response) => {
            // NOTE: The backend updates the course's hasConflict status, so we make another call to reflect this here
            // in the UI's color
            loadData()
          })
          this.notifySuccess('Successfully removed \'' + courseToRemove.title + '\' from your stream.')
          this.showRemoveCoursePopover = false
        }
      },
      removeButtonClicked (course, target) {
        this.clearLastClickedCell()
        target.setAttribute('id', 'courseToRemoveContainer')
        this.courseToRemove = course.courseData
        this.lastClickedCell = target
        this.showRemoveCoursePopover = !this.showRemoveCoursePopover
      },
      removeButtonClickedDiv (course, event) {
        this.clearLastClickedCell()
        event.target.setAttribute('id', 'courseToRemoveContainer')
        this.courseToRemove = course
        this.lastClickedCell = event.target
        this.showRemoveCoursePopover = !this.showRemoveCoursePopover
      },
      courseSelected (course, event) {
        this.clearLastClickedCell()
        this.courseToRemove = course
        this.showRemoveCoursePopover = false
      },
      courseHasConflict (course) {
        let hasConflict = false
        if (course.meetingDaysFormatted) {
          course.meetingDaysFormatted.forEach(function (meetingDay) {
            if (meetingDay.conflict) {
              hasConflict = true
            }
          })
        }
        return hasConflict
      },
      getFormattedDayAndTimeStrings (course) {
        let days = ''
        let times = ''

        if (course.meetingDaysRaw) {
          course.meetingDaysRaw.forEach(function (meetingDay) {
            days += (meetingDay.day) ? (meetingDay.day + ' ') : ''
            times += (meetingDay.meetingFromTime) ? (meetingDay.meetingFromTime + ' - ' + meetingDay.meetingToTime + ' ') : ''
          })
        }
        return {days: days, times: times}
      },
      hideRemoveCoursePopover () {
        this.courseToRemove = {}
        this.showRemoveCoursePopover = false
      },
      googleCalendarSyncSuccess (message) {
        this.notifySuccess(message)
      },
      googleCalendarSyncFailure (message) {
        this.notifyFailure(message)
      },
      clearLastClickedCell () {
        // remove the target id from any existing elements to display the popover
        // on the correct element
        let existingPopover = this.lastClickedCell
        if (existingPopover && existingPopover.setAttribute) {
          existingPopover.setAttribute('id', '')
        }
      },
      setActiveClass (courseBlockId) {
        $('.course_class_time').removeClass('active')
        $('#' + courseBlockId).addClass('active')
      },
      removeActiveClass () {
        $('.course_class_time').removeClass('active')
      },
      resetScheduleCalendarDetails () {
        $('.weekday_header .weekday').css({
          'width': 0
        })
        $('.time_slot_section .course_class_time').css({
          'width': 0
        })
        $('.conflict').css({
          'width': 0
        })

        $('.time_slot_section .tuesday').css({
          'left': 0
        })
        $('.time_slot_section .wednesday').css({
          'left': 0
        })
        $('.time_slot_section .thursday').css({
          'left': 0
        })
        $('.time_slot_section .friday').css({
          'left': 0
        })
        $('.time_slot_section .saturday').css({
          'left': 0
        })
        $('.time_slot_section .sunday').css({
          'left': 0
        })
      },
      setCourseTimingInCalendar (courseBlockId, course) {
        let day = course.day
        let startTime = course.meetingFromTimeFormatted
        let endTime = course.meetingToTimeFormatted
        let isConflict = course.conflict

        // let conflictCount = course.conflictCount // NOTE: unused
        // let initialValue = 8 // NOTE: unused

        let updateStartTimeValue = startTime.replace(/:/g, '_')
        let splittedTime = updateStartTimeValue.split('_')
        let startTimeInMinute = ((parseInt(splittedTime[0]) * 60) + parseInt(splittedTime[1]))

        // NOTE: diffFromInitial unused
        // let diffFromInitial = (480 - ((parseInt(splittedTime[0]) - initialValue) * 60 + parseInt(splittedTime[1])))

        let courseTimeDuration = ((new Date('1970-1-1 ' + endTime) - new Date('1970-1-1 ' + startTime)) / 1000 / 60)

        $('#' + courseBlockId).css({
          'top': (startTimeInMinute - 480) + 'px',
          'height': courseTimeDuration + 'px'
        })

        let conflictDayTimeClass = 'class_' + day + '_' + splittedTime[0]

        // check conflict state
        if (isConflict) {
          let dayTimeClass = $.find('.' + conflictDayTimeClass)
          if (dayTimeClass.length >= 0) {
            let conflictCount = dayTimeClass.length + 1

            course.conflictCount = conflictCount - 1
            $('#' + courseBlockId).addClass('conflict_number_' + conflictCount)
            $('#' + courseBlockId).css({
              'z-index': splittedTime[0]
            })
          }
          let conflictClass = 'conflict ' + conflictDayTimeClass
          $('#' + courseBlockId).addClass(conflictClass)
        } else {
          let conflictClass = 'no-conflict ' + conflictDayTimeClass
          $('#' + courseBlockId).addClass(conflictClass)
        }
      },
      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      }
    },
    computed: {
      ...mapState({
        'courses': state => state.semester.courses,
        'iCalFile': state => state.semester.iCalFile,
        'packages': state => state.institution.packages
      }),
      formattedCourses () {
        let formattedEntries = []
        // compile the meetingDaysRaw objects into a 'days' and 'times' string for each course
        // join each Instructor name with commas and a penultimate 'and'
        let index = 0
        let courses = this.courses

        let formatInstructorName = this.getFormattedInstructorName
        let getFormattedDayAndTime = this.getFormattedDayAndTimeStrings
        let courseHasConflict = this.courseHasConflict

        courses.forEach(function (obj) {
          let formattedDayAndTime = getFormattedDayAndTime(obj)

          let currCourse = {
            index: index,
            CRN: obj.crn,
            courseName: obj.title,
            // courseName: obj.departmentCode + ' ' + obj.num, // TODO remove after 12/20 demo, not all courses have this
            days: formattedDayAndTime['days'],
            time: formattedDayAndTime['times'],
            numberOfUnits: obj.creditHour,
            professorOrInstructor: formatInstructorName(obj),
            meetingDaysRaw: obj.meetingDaysRaw,
            meetingDaysFormatted: obj.meetingDaysFormatted,
            hasConflict: courseHasConflict(obj),
            block: (obj.block) ? obj.block.join(', ') : '',
            gradeLevel: (obj.gradeLevel) ? obj.gradeLevel.join(', ') : '',
            courseData: obj
          }
          formattedEntries.push(currCourse)
          index += 1
        })
        return formattedEntries
      },
      formattedCoursesForDivs () {
        let formattedEntries = []
        let courses = this.courses

        let getFormattedDayAndTime = this.getFormattedDayAndTimeStrings
        let formatInstructorName = this.getFormattedInstructorName

        courses.forEach((course) => {
          let instructorName = formatInstructorName(course)
          let formattedDayTime = getFormattedDayAndTime(course)
          if (course.meetingDaysFormatted) {
            course.meetingDaysFormatted.forEach((meetingDay) => {
              let courseFormatted = {}
              courseFormatted.uuid = course.uuid
              courseFormatted.title = course.title
              courseFormatted.day = meetingDay.day
              courseFormatted.conflict = meetingDay.conflict
              courseFormatted.conflictCount = 0
              courseFormatted.meetingToTimeFormatted = meetingDay.meetingToTimeFormatted
              courseFormatted.meetingFromTimeFormatted = meetingDay.meetingFromTimeFormatted
              courseFormatted.professorOrInstructor = instructorName
              courseFormatted.days = formattedDayTime['days']
              courseFormatted.times = formattedDayTime['times']
              courseFormatted.CRN = course.crn
              courseFormatted.numberOfUnits = course.creditHour
              courseFormatted.block = (course.block) ? course.block.join(', ') : ''
              courseFormatted.gradeLevel = (course.gradeLevel) ? course.gradeLevel.join(', ') : ''
              formattedEntries.push(courseFormatted)
            })
          }
        })
        return formattedEntries
      },
      scheduleCheckFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.SCHEDULE_CHECK_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/semester/components/SemesterCalendarView.vue